(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicMenuController', TopicMenuController);

    /* @ngInject */
    function TopicMenuController($scope, $state, $mdDialog, $mdPanel, Topic, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, CONTENT_META, $translate, Feature) {
        var vm = this;

        vm.loadingData = true;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;

        vm.filters = {
            metaType: 'all',
            enabled: false,
            allowScan: false,
            externalId: false,
            status: null,
        };

        if ( getSavedFilters() ) {
            vm.filters = getSavedFilters();
        }

        vm.updateFilters = function() {
            saveFilters(vm.filters);
            $scope.$emit('updateTopicList', vm.filters);
        }

        function saveFilters(filterData) {
            sessionStorage.setItem('objectMenu', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectMenu'));
        };

        vm.loadAll = function() {
            vm.loadingData = false;
        }
        vm.loadAll();
    }
})();
